import type { PracticeInvitationSummary } from "@ohf/core";
import { ApiError, createApiClient, type ApiClientOptions } from "../lib/api.js";

/** The only real-actor commands exposed inside an administrator preview. */
export interface PublicSharingLinks {
  createPracticeInvitation(partyId: string): Promise<PracticeInvitationSummary>;
  createRepresentativeInvitation(partyId: string): Promise<{ joinPath: string }>;
}

export function createPublicSharingLinks(options: Omit<ApiClientOptions, "viewAsUserId">): PublicSharingLinks {
  // Construct the real-actor client here; callers never receive a generic client.
  const api = createApiClient({ ...options, viewAsUserId: undefined });
  function target(partyId: string) {
    if (!partyId.trim()) throw new ApiError(400, "party_required");
    return { partyId };
  }
  return {
    createPracticeInvitation: partyId => api.post("/practice-invitations", target(partyId)),
    createRepresentativeInvitation: partyId => api.post("/rep-join-referrals/link", target(partyId)),
  };
}
